(function() {
'use strict';

angular
    .module('TR')
    .service('marhabaSearchValidator', marhabaSearchValidator);

function marhabaSearchValidator(resourceService, dateUtil, occupancyService) {
    const service = {
        validate
    };

    function validate(terminal, airport, date, occupancy) {
        const errors = [];
        const maxPassengers = 9;

        if (!terminal || terminal.Id === 0) {
            errors.push(resourceService.get('VALIDATESELECTTERMINAL'));
        }

        if (!airport) {
            errors.push(resourceService.get('VALIDATESELECTAIRPORT'));
        }

        if (occupancy.Adults + occupancy.ChildAges.length > maxPassengers) {
            errors.push(String.format(resourceService.get('TOOMANYTRANSFERPASSENGERS'), maxPassengers));
        }

        if (!occupancyService.childAgesPopulated(occupancy)) {
            errors.push(resourceService.get('CHILDAGESERROR'));
        }

        if (!dateUtil.atLeastTwoDaysInTheFuture(date)) {
            errors.push(resourceService.get('VALIDATETWODAYSINTHEFUTURE'));
        }

        return errors;
    }

    return service;
}
})();
